<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" v-model="localVisible" :confirmLoading="loading" :maskClosable="false"
        :ok-button-props="{ props: { disabled: !innerForm.id && (suffixLoading || Boolean(suffixError)) } }"
        @cancel="cancel" @ok="confirm">
      <div slot="title">{{ innerForm.id ? '编辑账号' : '新增账号' }}</div>
      <div>
        <a-form-model ref="form" :model="innerForm" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="username" label="用户名">
            <a-input
              v-model="innerForm.username"
              :disabled="Boolean(innerForm.id)"
              :placeholder="innerForm.id ? '' : '请输入用户名主体'"
            >
              <span v-if="!innerForm.id" slot="addonAfter">{{ usernameSuffix || '加载中' }}</span>
            </a-input>
            <div v-if="!innerForm.id && suffixError" class="suffix-error">{{ suffixError }}</div>
          </a-form-model-item>
          <a-form-model-item prop="name" label="员工姓名">
            <a-input v-model="innerForm.name" />
          </a-form-model-item>
          <a-form-model-item prop="phone" label="手机号">
            <a-input v-model="innerForm.phone" />
          </a-form-model-item>
          <a-form-model-item prop="email" label="邮箱">
            <a-input v-model="innerForm.email" />
          </a-form-model-item>
          <a-form-model-item prop="sex" label="性别">
            <a-select default-value="man" style="width: 100%" v-model="innerForm.sex">
              <a-select-option value="man"> 男 </a-select-option>
              <a-select-option value="woman"> 女 </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="is_active" label="状态">
            <a-select v-model="innerForm.is_active" style="width: 100%;">
              <a-select-option :value="true">启用</a-select-option>
              <a-select-option :value="false">禁用</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="roles" label="角色">
            <a-select v-model="innerForm.roles" mode="multiple" allowClear style="width: 100%;">
              <a-select-option v-for="item in roleItems" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>

        <div v-if="!innerForm.id" style="color: rgb(255, 77, 79); text-align: center;">
          默认初始密码为: 123456, 登录后请修改密码
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { userCreate, userUpdate, userUsernameSuffix } from '@/api/account'
  import Cookies from 'js-cookie'
  import { buildSubmittedUsername, decodeJwtPayload, getTeamUsernameSuffix } from './account-username-suffix'
  import rules from './rules.js'

  export default {
    name: 'FormModal',
    model: { prop: 'visible', event: 'cancel' },
    props: {
      visible: { type: Boolean, default: false },
      form: { type: Object, default: () => ({}) },
      roleItems: { type: Array, default: () => [] },
    },
    data() {
      return {
        rules,
        loading: false,
        localVisible: this.visible,
        innerForm: this.cloneForm(this.form),
        usernameSuffix: '',
        suffixLoading: false,
        suffixError: '',
        submitFullUsername: false,
      };
    },
    watch: {
      visible(v) {
        this.localVisible = v;
        if (v) {
          this.innerForm = this.cloneForm(this.form);
          if (!this.innerForm.id) this.loadUsernameSuffix();
        }
      },
      form(v) {
        this.innerForm = this.cloneForm(v);
      },
    },
    methods: {
      cloneForm(src) {
        return JSON.parse(JSON.stringify(src || {}));
      },
      async loadUsernameSuffix() {
        this.suffixLoading = true;
        this.suffixError = '';
        this.usernameSuffix = '';
        this.submitFullUsername = false;
        try {
          const data = await userUsernameSuffix();
          this.usernameSuffix = data.suffix;
          this.submitFullUsername = false;
          if (!this.usernameSuffix) throw new Error('suffix is empty');
        } catch (error) {
          try {
            const payload = decodeJwtPayload(Cookies.get('access'));
            this.usernameSuffix = getTeamUsernameSuffix(payload && payload.team_id);
            this.submitFullUsername = true;
          } catch (fallbackError) {
            this.submitFullUsername = false;
          }
          this.suffixError = '公司用户名后缀加载失败，请检查公司名称';
          if (this.usernameSuffix) this.suffixError = '';
        } finally {
          this.suffixLoading = false;
        }
      },
      confirm() {
        if (!this.innerForm.id && (this.suffixLoading || this.suffixError || !this.usernameSuffix)) {
          this.$message.error(this.suffixError || '公司用户名后缀正在加载');
          return;
        }
        this.$refs.form.validate(valid => {
          if (!valid) return;
          this.loading = true;
          const payload = { ...this.innerForm };
          if (!payload.id) payload.username = buildSubmittedUsername(payload.username, this.usernameSuffix, this.submitFullUsername);
          const func = payload.id ? userUpdate : userCreate;
          func(payload).then(data => {
            this.$message.success(payload.id ? '修改成功' : '新增成功');
            this.$emit(payload.id ? 'update' : 'create', data);
            this.cancel();
          }).finally(() => {
            this.loading = false;
          });
        });
      },
      cancel() {
        this.$emit('cancel', false);
        this.usernameSuffix = '';
        this.suffixError = '';
        this.suffixLoading = false;
        this.submitFullUsername = false;
        if (this.$refs.form) this.$refs.form.resetFields();
      },
    },
  }
</script>

<style scoped>
.suffix-error {
  color: #ff4d4f;
  line-height: 1.5;
  margin-top: 4px;
}
</style>
